import { render } from "./FormClienteDetalle.vue?vue&type=template&id=4499d9f0"
import script from "./FormClienteDetalle.vue?vue&type=script&lang=js"
export * from "./FormClienteDetalle.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__